<script setup>
import { ref, onMounted, computed } from 'vue';

const props = defineProps(['userId']);
const channels = ref({});

const fetchChannels = async () => {
    fetch('/api/channels', {
        headers: {
            Accept: 'application/json'
        }
    }).then(async (response) => {
        channels.value = await response.json();
        channels.value.data?.forEach(channel => {
            listenForChannelUpdates(channel);
        });

    }).catch((error) => console.log(error));
}

const listenForChannelUpdates = (channel) => {
    Echo.private(`channels.${channel.id}`)
        .listen('.new.message', (e) => {
            if (e.message.user.id != props.userId) {
                channel.new = channel.new + 1;
                try {
                    if (Notification.permission === 'granted') {
                        const notification = new Notification('Neue Nachricht von ' + e.message.user.fullname, {
                            body: e.message.message,
                            icon: '/images/icons/mstile-70x70.png'
                        });
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        }).listen('.read.message', (e) => {
            if (e.message.user.id != props.userId) {
                channel.new = channel.new - 1;
            }
        }).listen('.remove.channel', (e) => {
            channels.value.data = channels.value.data.filter(channel => channel.id !== e.channel.id);
            Echo.leave(`channels.${channel.id}`);
        });
}

const listenForNewChannells = () => {
    Echo.private(`users.${props.userId}.channels`)
        .listen('.new.channel', (e) => {
            channels.value.data.unshift(e.channel);
            listenForChannelUpdates(channels.value.data[0]);
        });
}

const newMessages = computed(() => {
    return channels.value.data?.reduce((accumulator, channel) => {
        return accumulator + channel.new;
    }, 0);
});

onMounted(() => {
    try {
        if (Notification.permission !== 'granted' && Notification.permission !== 'denied') {
            Notification.requestPermission();
        }
    } catch (error) {
        console.error(error);
    }
    fetchChannels();
    listenForNewChannells();
});

</script>

<template>
    <div v-if="newMessages"
        class="tw-absolute tw-rounded-full tw-bg-secondary-500 tw-text-white -tw-top-1.5 -tw-right-1.5 tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-bold">
        {{ newMessages }}
    </div>
</template>
